import { defineStore } from "pinia";
import { ref } from "vue";
import { Product } from "@/core/models/product";

const useTypesenseStore = defineStore("typesense", () => {
  const organizationIndexName = ref<string | null>(null);
  const loadingToken = ref<boolean>(false);
  const search = ref<string | null>(null);
  const savedSearch = ref<string | null>(null);
  const results = ref<Product[]>([]);

  function setAsLoading(): void {
    loadingToken.value = true;
  }
  function setAsFinished(): void {
    loadingToken.value = false;
  }

  function setSearchValue(value: string | null): void {
    if (value !== null) {
      search.value = value;
    }
  }

  function saveSearchValue(): void {
    savedSearch.value = search.value;
  }

  function setProductResults(value: Product[]): void {
    results.value = value;
  }

  function resetSearch(): void {
    search.value = null;
    savedSearch.value = null;
    results.value = [];
  }

  return {
    organizationIndexName,
    loadingToken,
    search,
    savedSearch,
    results,
    setAsLoading,
    setAsFinished,
    setSearchValue,
    saveSearchValue,
    setProductResults,
    resetSearch,
  };
});

export default useTypesenseStore;
